/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Assignment data
 * @export
 * @interface AssignWeaknessRequest
 */
export interface AssignWeaknessRequest {
    /**
     * 
     * @type {string}
     * @memberof AssignWeaknessRequest
     */
    assignedTo?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignWeaknessRequest
     */
    assignedToEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof AssignWeaknessRequest
     */
    assignedToType?: AssignWeaknessRequestAssignedToTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AssignWeaknessRequest
     */
    reason?: string;
}


/**
 * @export
 */
export const AssignWeaknessRequestAssignedToTypeEnum = {
    Individual: 'INDIVIDUAL',
    Team: 'TEAM',
    Group: 'GROUP'
} as const;
export type AssignWeaknessRequestAssignedToTypeEnum = typeof AssignWeaknessRequestAssignedToTypeEnum[keyof typeof AssignWeaknessRequestAssignedToTypeEnum];


/**
 * Check if a given object implements the AssignWeaknessRequest interface.
 */
export function instanceOfAssignWeaknessRequest(value: object): value is AssignWeaknessRequest {
    return true;
}

export function AssignWeaknessRequestFromJSON(json: any): AssignWeaknessRequest {
    return AssignWeaknessRequestFromJSONTyped(json, false);
}

export function AssignWeaknessRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssignWeaknessRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'assignedTo': json['assignedTo'] == null ? undefined : json['assignedTo'],
        'assignedToEmail': json['assignedToEmail'] == null ? undefined : json['assignedToEmail'],
        'assignedToType': json['assignedToType'] == null ? undefined : json['assignedToType'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function AssignWeaknessRequestToJSON(json: any): AssignWeaknessRequest {
    return AssignWeaknessRequestToJSONTyped(json, false);
}

export function AssignWeaknessRequestToJSONTyped(value?: AssignWeaknessRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignedTo': value['assignedTo'],
        'assignedToEmail': value['assignedToEmail'],
        'assignedToType': value['assignedToType'],
        'reason': value['reason'],
    };
}

